<template>
  <header id="site-header" class="site-header" :class="{ 'open' : isOpen }">
    <div class="content-max-width flex">

      <a href="/home" class="logo">
        <img src="/images/header-logo.svg" alt="Cass Medical" />
      </a>

      <nav>
        <ul class="top">
          <li class="mobile" :class="{ active: ['/', '/home'].includes(currentPath) }">
            <a href="/">Home</a>
          </li>
          <li
            v-for="(link, index) of data"
            :key="index"
            :class="{ active: currentPath == link.url }"
          >
            <a :href="link.url">{{ link.title }}</a>
          </li>
        </ul>
      </nav>

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf','data', 'logged_in'
  ],

  data () {
    return {
      isOpen: false,
    }
  },

  computed: {
    currentPath () {
      return window.location.pathname
    },
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue